module.exports = __webpack_public_path__ + "site/img/56.47ad059e.jpg";